import React, { FunctionComponent } from "react";
import { connect, MapStateToProps, MergeProps } from "react-redux";

import { ButtonBackgroundColor, Display, JustifyContent, Layout, SpacingSize, TextButton, TextColor } from "@multiweb/reactComponents";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState, QAProps } from "@multiweb/types/react";
import { LOC_EXPLORE, LOC_MANAGE } from "../../../locKeys";
import { isWorkflowReadOnly } from "../../../selectors";
import { WorkflowEditorProps } from "../../../types";

type ManageButtonComponentProps = {
    readonly onClick: () => void;
    readonly text: string;
} & QAProps;

const ManageButtonComponent: FunctionComponent<ManageButtonComponentProps> = ({ onClick, text }) => (
    <Layout display={Display.flex} justifyContent={JustifyContent.center} spacingSizeVertical={SpacingSize.s} >
        <TextButton
            qa={"manage-btn"}
            color={TextColor.whiteBlack}
            backgroundColor={ButtonBackgroundColor.buttonPrimary}
            {...{ onClick, text } } />
    </Layout>
);

type ManageButtonProps = Pick<ManageButtonComponentProps, "onClick" | "qa"> & WorkflowEditorProps;

type StateProps = {
    readonly isWorkflowReadOnly: boolean;
    readonly manageText: string;
    readonly exploreText: string;
};

const mapStateToProps: MapStateToProps<StateProps, ManageButtonProps, IAppState> = (state, { hostKey }) => ({
    isWorkflowReadOnly: isWorkflowReadOnly(state, hostKey),
    manageText: getPrimaryText(state, LOC_MANAGE) ?? "Spravovat",
    exploreText: getPrimaryText(state, LOC_EXPLORE) ?? "Prozkoumat",
});

const mergeProps: MergeProps<StateProps, undefined, ManageButtonProps, ManageButtonComponentProps> = (
    { isWorkflowReadOnly, manageText, exploreText },
    _dispatchProps,
    ownProps) => ({
    ...ownProps,
    text: isWorkflowReadOnly ? exploreText : manageText,
});

export const ManageButton = connect(mapStateToProps, undefined, mergeProps)(ManageButtonComponent);
